import { render, staticRenderFns } from "./PlaceTolocca.vue?vue&type=template&id=17df27ae&"
import script from "./PlaceTolocca.vue?vue&type=script&lang=js&"
export * from "./PlaceTolocca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports